import { FC, useCallback } from 'react'
import styles from 'components/features/pfm/PostAddTagAction/PostAddTagAction.styl'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { ComposeId } from 'interfaces/feed'
import { composeExecCommandActionCreator } from 'actions/feedComposeActions'

type PostAddTagAction = {
  composeId: ComposeId
}

export const PostAddTagAction: FC<PostAddTagAction> = ({ composeId }) => {
  const dispatch = useStoreDispatch()

  const handleAddTag = useCallback(() => {
    dispatch(composeExecCommandActionCreator({
      composeId,
      command: {
        type: 'startTag',
      },
    }))
  }, [composeId, dispatch])

  return (
    <button
      className={ styles.tagButton }
      onClick={ handleAddTag }
    >
      Add Tag
    </button>
  )
}
